import React from "react";
import AnimatedHeading from "../AnimatedHeading";
import { IMG } from "../../assetsBase";

function Process() {
  return (
    <section className="orbia-process_one p-r z-1 pt-55 pb-120">
      <div className="process-shape">
        <img src={`${IMG}/gallery/process-shape.png`} alt="shape" />
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="section-title text-center mb-55">
              <span
                className="sub-title"
                data-aos="fade-down"
                data-aos-duration="1000"
              >
                How We Work
              </span>
              <AnimatedHeading>One Process. Three Areas of Expertise.</AnimatedHeading>
              <p data-aos="fade-up" data-aos-duration="1200">
                Whether you need a digital product, business support, or a
                reliable supply partner, we follow the same disciplined
                process to get you there.
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="process-wrapper">
              <div
                className="orbia-process-box"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <div className="content">
                  <img
                    src={`${IMG}/gallery/process-sh1.png`}
                    alt="process shape"
                  />
                  <h4 className="title">Discovery & Consultation</h4>
                </div>
              </div>
              <div
                className="orbia-proces-arrow-box"
                data-aos="fade-up"
                data-aos-duration="1200"
              >
                <div className="content">
                  <img
                    src={`${IMG}/gallery/process-arrow.png`}
                    alt="process shape"
                  />
                  <p>Understanding Your Goals</p>
                </div>
              </div>
              <div
                className="orbia-process-box-wrap"
                data-aos="fade-up"
                data-aos-duration="1400"
              >
                <div className="orbia-process-circle-box bg_one">
                  <div className="content">
                    <img
                      src={`${IMG}/gallery/process-sh2.png`}
                      alt="process shape"
                    />
                    <h4 className="title">
                      Planning &amp; <br /> Strategy
                    </h4>
                  </div>
                </div>
                <div className="orbia-process-circle-box bg_two">
                  <div className="content">
                    <p>
                      We shape a tailored plan, drawing on the right mix of
                      technical, business, or supply expertise for your
                      specific needs.
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="orbia-proces-arrow-box"
                data-aos="fade-up"
                data-aos-duration="1600"
              >
                <div className="content">
                  <img
                    src={`${IMG}/gallery/process-arrow.png`}
                    alt="process shape"
                  />
                  <p>Aligning On the Approach</p>
                </div>
              </div>
              <div
                className="orbia-process-box"
                data-aos="fade-up"
                data-aos-duration="1800"
              >
                <div className="content">
                  <img
                    src={`${IMG}/gallery/process-sh3.png`}
                    alt="process shape"
                  />
                  <h4 className="title">Delivery & Support</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Process;
